<template>
    <v-container
      class="ma-0 pa-0"
      fluid
      style="height: calc(100vh - 96px); max-height: calc(100vh - 96px); overflow-y: hidden; width: 100%"
    >
    </v-container>
</template>
<script>
  
  export default {
        name: "WelcomePage",
        components: {
        },
        mounted() {
        },
        watch: {
        },
        data: () => ({
        })
    }
</script>